import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { Observable } from 'rxjs';
import { GenericPaginated } from '../../models/generic-paginated';
import { PaymentTransaction } from '../../models/payment-transaction';
import { WalletTransaction } from '../../models/wallet-transaction';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {
  private baseUrl = environment.url;

  private http = inject(HttpClient)
  private addParamsService = inject(AddParamsService)

  getPaymentTransactionsList = (params?: Params): Observable<GenericPaginated<PaymentTransaction>> => {
    return this.http.get<GenericPaginated<PaymentTransaction>>(`${this.baseUrl}/payment-transactions`, {
      params: this.addParamsService.addParams(params)
    });
  }

  getWalletTransactionsList = (params?: Params): Observable<GenericPaginated<WalletTransaction>> => {
    return this.http.get<GenericPaginated<WalletTransaction>>(`${this.baseUrl}/wallet-transactions`, {
      params: this.addParamsService.addParams(params)
    });
  }
}